document.querySelectorAll("[animated-content] h1, [animated-content] h2, [animated-content] h3").forEach(heading => {
	for (let node of Array.from(heading.childNodes)) {
		if (node.nodeType === Node.TEXT_NODE) {
			let words = node.textContent.split(/\s/g);

			node.replaceWith(...words.map(word => {
				let span = document.createElement("span");
				span.textContent = word;
				span.innerHTML += "&nbsp;";
				span.setAttribute("scrollable", "");

				return span;
			}));
		}
		else if (node instanceof HTMLBRElement) {
			let lineBreak = document.createElement("span");
			lineBreak.setAttribute("br", "");

			node.replaceWith(lineBreak);
		}
	}
});

document.querySelectorAll("[animated-content] p, [animated-content] h4").forEach(paragraph => {
	paragraph.setAttribute("scrollable", "");
});